import { useStoreConfig } from '~/store/storeConfig'
import type { QueryKeys } from '~/types/storeTypes'
import getDefaultCountryId from '~/utils/countries/getDefaultCountryId'

export const useQueryKeyWatch = () => {
  const locale = useState<string>('locale.setting')
  const storeConfig = useStoreConfig()
  const defaultCountryId = getDefaultCountryId()
  let stopWatch: (() => void) | undefined

  const setQueryKeys = (locale: string) => {
    const currentStoreQueryKeys =
      storeConfig.getQueryKeys?.find(
        (keys: QueryKeys) =>
          keys.countryId === defaultCountryId && storeConfig.getAvailableLocales?.[locale]?.id === keys.languageId
      ) ?? null

    storeConfig.setCurrentKeys(currentStoreQueryKeys)
  }

  const initWatch = () => {
    stopWatch = watch(locale, (newLocale: string) => {
      setQueryKeys(newLocale)
    })
  }

  onBeforeUnmount(() => {
    if (stopWatch) {
      stopWatch()
    }
  })

  return {
    setQueryKeys,
    initWatch,
  }
}
